import { render } from "./TheMenuItems.vue?vue&type=template&id=7665ce7f&scoped=true"
import script from "./TheMenuItems.vue?vue&type=script&lang=js"
export * from "./TheMenuItems.vue?vue&type=script&lang=js"

import "./TheMenuItems.vue?vue&type=style&index=0&id=7665ce7f&scoped=true&lang=css"

import exportComponent from "/Users/timothyjoseph/Projects/simplest-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7665ce7f"]])

export default __exports__